var map = {
	"./American Express.svg": 889,
	"./Diners.svg": 890,
	"./Discover.svg": 891,
	"./JCB.svg": 892,
	"./Kor-dark-logo.svg": 56,
	"./Kor-logo.svg": 94,
	"./MasterCard.svg": 893,
	"./Unionpay.svg": 894,
	"./Visa.svg": 895,
	"./bell-icon.svg": 310,
	"./burger-icon.svg": 193,
	"./folder.svg": 194,
	"./icons/Close.svg": 896,
	"./icons/Delete.svg": 897,
	"./icons/Deployed.svg": 898,
	"./icons/FileCode.svg": 899,
	"./icons/Functions.svg": 900,
	"./icons/FunctionsLight.svg": 901,
	"./icons/GitPullRequest.svg": 195,
	"./icons/Habitat.svg": 902,
	"./icons/HabitatLight.svg": 83,
	"./icons/Inactive.svg": 903,
	"./icons/Overview.svg": 904,
	"./icons/Pause.svg": 905,
	"./icons/Plus.svg": 906,
	"./icons/Settings.svg": 907,
	"./icons/UserCircle.svg": 59,
	"./icons/arrowd.svg": 908,
	"./icons/arrowr.svg": 909,
	"./icons/check.svg": 305,
	"./icons/close-icon.svg": 43,
	"./icons/deploy.svg": 304,
	"./icons/exclamation.svg": 306,
	"./icons/eye-open.svg": 196,
	"./icons/git.svg": 302,
	"./icons/gitBranch.svg": 910,
	"./icons/gitName.svg": 911,
	"./icons/gitNoBranch.svg": 912,
	"./icons/habitats-sub-menu/Costs.svg": 913,
	"./icons/habitats-sub-menu/Logs.svg": 914,
	"./icons/habitats-sub-menu/ReleaseManagement.svg": 915,
	"./icons/habitats-sub-menu/Reporting.svg": 916,
	"./icons/habitats-sub-menu/Settings.svg": 917,
	"./icons/member.svg": 918,
	"./icons/overview/arrow-right.svg": 95,
	"./icons/overview/folder.svg": 119,
	"./icons/overview/habitaticon.svg": 189,
	"./icons/overview/load.svg": 188,
	"./icons/overview/plus.svg": 63,
	"./icons/overview/staticsiteicon.svg": 190,
	"./icons/overview/strapi.svg": 191,
	"./icons/overview/webappicon.svg": 192,
	"./icons/owner.svg": 919,
	"./icons/people.svg": 920,
	"./icons/person.svg": 921,
	"./icons/powerbutton.svg": 922,
	"./icons/pushpin.svg": 197,
	"./icons/python.svg": 303,
	"./icons/services/API-Gateway.svg": 923,
	"./icons/services/AWS-Lambda.svg": 924,
	"./icons/services/Amazon-DynamoDB.svg": 925,
	"./icons/services/Amazon-Simple-Notification.svg": 926,
	"./icons/services/DynamoDBStreams.svg": 927,
	"./icons/services/Elasticsearch.svg": 928,
	"./icons/services/Kinesis.svg": 929,
	"./icons/services/S3.svg": 930,
	"./icons/strapi.svg": 121,
	"./icons/trash.svg": 104,
	"./lifebuoy-icon.svg": 198,
	"./magnet.svg": 97,
	"./powerbutton.svg": 931,
	"./powerbutton1.svg": 199,
	"./settings-icon.svg": 200
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 888;